import { render, staticRenderFns } from "./AllocationInHouseSteps.vue?vue&type=template&id=4a12fcfd"
import script from "./AllocationInHouseSteps.vue?vue&type=script&lang=js"
export * from "./AllocationInHouseSteps.vue?vue&type=script&lang=js"
import style0 from "./AllocationInHouseSteps.vue?vue&type=style&index=0&id=4a12fcfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports